import { Global, css, keyframes } from "@emotion/react";
import styled from "@emotion/styled";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { LoadingButton } from "@mui/lab";
import { Button, useMediaQuery } from "@mui/material";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import { sendSlackError } from "@src/api/error";
import { subscribeStibee } from "@src/api/sign";
import WebpImage from "@src/component/base/WebpImage";
import { EmptySpace } from "@src/component/SignComponent";
import useUser from "@src/hook/useUser";
import { faqListClient } from "@src/model/applicationModel";
import { Empty, GroupA, ModalA, PaperA, useModal } from "@src/ruix";
import {
	defaultMessageAtom,
	globalSnackbarState,
	isApplyOpenAtom,
	isChatOpenAtom,
	userInfoAtom,
} from "@src/state";
import { validateEmail } from "@src/utils/sign";
import { useRouter } from "next/router";
import React, { useEffect, useState } from "react";
import TagManager from "react-gtm-module";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { Autoplay, Navigation, Pagination, Scrollbar } from "swiper/modules";
import { Swiper as SwiperComponent, SwiperSlide } from "swiper/react";

export const MainContentsMobile = () => {
	const { user } = useUser();
	const router = useRouter();

	const setDefaultMessage = useSetRecoilState(defaultMessageAtom);
	const setSnackbareState = useSetRecoilState(globalSnackbarState);

	const setIsApplyOpen = useSetRecoilState(isApplyOpenAtom);
	const setIsChatOpen = useSetRecoilState(isChatOpenAtom);
	const userInfo = useRecoilValue(userInfoAtom);

	useEffect(() => {
		const scrollFunction = () => {
			if (scrollY > (document.querySelector("#client-apply-mid") as any)?.offsetHeight) {
				document.querySelector(".floating")?.classList.remove("hidden");
			} else {
				document.querySelector(".floating")?.classList.add("hidden");
			}
		};
		window.addEventListener("scroll", scrollFunction);
		return () => {
			window?.removeEventListener("scroll", scrollFunction);
		};
	}, []);

	const 플로팅버튼 = () => (
		<div className="floating column-center-center">
			<div
				onClick={() => {
					if (user.isLogin && user.userType === 2) {
						setSnackbareState(
							"고객사 전용 서비스입니다.\n문의사항은 우측 하단 채널톡을 이용해주시기 바랍니다.",
						);
						return;
					}
					const tagManagerArgs = {
						dataLayer: {
							event: `client-apply-start`,
						},
					};
					if (!window.localStorage.getItem("accessToken")) {
						TagManager.dataLayer(tagManagerArgs);
					}
					setDefaultMessage("");
					if (user.isLogin) {
						setIsChatOpen(true);
					} else {
						setIsApplyOpen(true);
					}
				}}
				className="floating-btn-apply apply-button"
			>
				<div>지금 바로 상담 받기</div>
			</div>
		</div>
	);
	return (
		<>
			<Global
				styles={css`
					.how-to-verify {
						border-radius: 20px;
						overflow: hidden;
						transition: transform 0.2s ease;
					}
				`}
			/>
			<MainContentsContainer className="column-center-start">
				<MainCtaContents />
				<CIList />
				<WhenWeNeed />
				<HowToVerify />
				<ExpertList />
				<GetProfileNewsLetter />
				<Purpose />
				<Process />
				<BestPractice />
				<ReviewList />
				<BlogSection />
				<FAQSection />
				{플로팅버튼()}
			</MainContentsContainer>
		</>
	);
};

const rollingNumbers = ["5", "10", "20"];

const MainCtaContents = () => {
	const { user } = useUser();
	const router = useRouter();

	const setIsApplyOpen = useSetRecoilState(isApplyOpenAtom);
	const setIsChatOpen = useSetRecoilState(isChatOpenAtom);
	const userInfo = useRecoilValue(userInfoAtom);
	const setDefaultMessage = useSetRecoilState(defaultMessageAtom);
	const setSnackbareState = useSetRecoilState(globalSnackbarState);

	const [numIndex, setNumIndex] = useState(0);

	useEffect(() => {
		const interval = setInterval(() => {
			setNumIndex((prev) => (prev + 1) % rollingNumbers.length);
		}, 2500);
		return () => clearInterval(interval);
	}, []);

	return (
		<MainCtaContentsContainer className="column-center-center">
			<ContentsContainer className="column-center-center">
				<MatinCtaContentsInner className="column-center-start">
					<h1
						className="cta-title-box"
						style={{
							margin: "0 auto",
						}}
					>
						<div className="row-center-center">
							<span>
								상위 <span className="blue">10%</span> 마케터를
							</span>
						</div>
						<div>
							<span>{"주"}</span>
							<MobileRollingTextSpan key={numIndex} className="blue">
								{rollingNumbers[numIndex]}
							</MobileRollingTextSpan>
							<span>{"시간 고용하세요"}</span>
						</div>
					</h1>
					<EmptySpace space={20} />
					<MainCtaButton
						variant="contained"
						id="client-apply-mid"
						className="apply-button"
						onClick={() => {
					if (user.isLogin && user.userType === 2) {
						setSnackbareState(
							"고객사 전용 서비스입니다.\n문의사항은 우측 하단 채널톡을 이용해주시기 바랍니다.",
						);
						return;
					}
							const tagManagerArgs = {
								dataLayer: {
									event: `client-apply-start`,
								},
							};
							if (!window.localStorage.getItem("accessToken")) {
								TagManager.dataLayer(tagManagerArgs);
							}
							setDefaultMessage("");
							if (user.isLogin) {
								setIsChatOpen(true);
							} else {
								setIsApplyOpen(true);
							}
						}}
					>
						지금 바로 상담 받기
					</MainCtaButton>
					<div
						onClick={() => {
						setDefaultMessage(
								`안녕하세요! 원포인트 AI 마케팅 상담봇입니다 🙂\n\n회사나 브랜드, 혹은 현재 상황이나 고민하고 계신 부분에 대해 편하게 말씀해주시면 차근차근 도와드릴게요!`,
							);
						if (user.isLogin && user.userType === 2) {
							setSnackbareState(
								"고객사 전용 서비스입니다.\n문의사항은 우측 하단 채널톡을 이용해주시기 바랍니다.",
							);
							return;
						}
						if (user.isLogin) {
								setIsChatOpen(true);
							} else {
								setIsApplyOpen(true);
							}
						}}
						className="ai-consult-button"
						style={{
							color: "#666666",
							textDecoration: "none",
							cursor: "pointer",
							fontSize: "12px",
							marginTop: "12px",
							transition: "all 0.2s ease",
							borderBottom: "1px solid transparent",
							paddingBottom: "2px",
							letterSpacing: "-0.3px",
						}}
						onTouchStart={(e) => {
							e.currentTarget.style.color = "var(--primary)";
							e.currentTarget.style.borderBottom = "1px solid var(--primary)";
						}}
						onTouchEnd={(e) => {
							e.currentTarget.style.color = "#666666";
							e.currentTarget.style.borderBottom = "1px solid transparent";
						}}
					>
						5분 안에 마케팅 진단 먼저 받아보기
					</div>
				</MatinCtaContentsInner>
			</ContentsContainer>
		</MainCtaContentsContainer>
	);
};
const WhenWeNeed = () => {
	const a = 1;

	return (
		<ContentsContainer className="column-center-start">
			<GroupA order="column-start-center" gap={20}>
				<SectionTitle>{`검증된 탑티어 프리랜서 마케터,\n언제 필요할까요?`}</SectionTitle>
			</GroupA>
			<EmptySpace space={40} />
			<PaperA fullWidth variant="transparent" order="column-start-between" gap={8} px={0} py={0}>
				<WhyCard
					imgSrc={WhyCardList[0].imgSrc}
					title={WhyCardList[0].title}
					subTitle={WhyCardList[0].subTitle}
				/>
				<WhyCard
					imgSrc={WhyCardList[1].imgSrc}
					title={WhyCardList[1].title}
					subTitle={WhyCardList[1].subTitle}
				/>
				<WhyCard
					imgSrc={WhyCardList[2].imgSrc}
					title={WhyCardList[2].title}
					subTitle={WhyCardList[2].subTitle}
				/>
				<WhyCard
					imgSrc={WhyCardList[3].imgSrc}
					title={WhyCardList[3].title}
					subTitle={WhyCardList[3].subTitle}
				/>
			</PaperA>
			<EmptySpace space={8} />
		</ContentsContainer>
	);
};
const HowToVerify = () => {
	const { openModal, isOpen, closeModal } = useModal();
	const router = useRouter();

	const isTablet = useMediaQuery("(min-width: 620px)");

	useEffect(() => {
		if (router.query["expert-evaluation-example"] === "true") {
			openModal();
		}
	}, [router.query]);

	return (
		<ContentsContainer>
			<ContentsContainer
				className="column-center-start how-to-verify"
				style={{
					background: "var(--bg-white)",
					padding: 0,
				}}
			>
				<Empty space={95} />
				<SectionTitle>3단계 검증 시스템으로</SectionTitle>
				<HowToVerrifyBigTitle>
					<span className="blue">상위 10% 마케터</span>
					<span>를 선발합니다</span>
				</HowToVerrifyBigTitle>
				<Empty space={60} />
				<div
					className="column-start-start"
					style={{
						gap: 40,
						width: "100%",
					}}
				>
					<div
						className="row-start-start"
						style={{
							paddingLeft: "24px",
							gap: 16,
							width: "100%",
						}}
					>
						<PentagonContainer className="row-center-between">
							<GroupA order="column-start-start">
								<HowToVerifyStepTitle>1단계</HowToVerifyStepTitle>
								<SectionSmallTitle>서류 평가</SectionSmallTitle>
								<Empty space={0} />
								<HowAnswerDiv>{`이력, 프로젝트 경험, 포트폴리오를 기반으로\n경력과 성과를 확인합니다`}</HowAnswerDiv>

								<Empty space={0} />
								<HowToAnswerDiv>{`지원자의 70%만 합격합니다`}</HowToAnswerDiv>
							</GroupA>
						</PentagonContainer>
					</div>
					<div
						className="row-start-start"
						style={{
							paddingLeft: "24px",
							gap: 16,
							width: "100%",
						}}
					>
						<PentagonContainer className="row-center-between">
							<GroupA order="column-start-start">
								<HowToVerifyStepTitle>2단계</HowToVerifyStepTitle>
								<SectionSmallTitle>역량 평가</SectionSmallTitle>
								<Empty space={0} />
								<HowAnswerDiv>{`논술형 평가를 통해 직무별\n문제 해결 역량과 스킬을 파악합니다`}</HowAnswerDiv>
								<Empty space={0} />
								<HowToAnswerDiv>{`지원자의 30%만 합격합니다`}</HowToAnswerDiv>
							</GroupA>
						</PentagonContainer>
					</div>
					<div
						className="row-start-start"
						style={{
							paddingLeft: "24px",
							gap: 16,
							width: "100%",
						}}
					>
						<PentagonContainer className="row-center-between">
							<GroupA order="column-start-start">
								<HowToVerifyStepTitle>3단계</HowToVerifyStepTitle>
								<SectionSmallTitle>심층 면접</SectionSmallTitle>
								<Empty space={0} />
								<HowAnswerDiv>{`커뮤니케이션 역량 및 적극성 등\n소프트 스킬을 검증합니다`}</HowAnswerDiv>
								<Empty space={0} />
								<HowToAnswerDiv>{`지원자의 10%만 합격합니다`}</HowToAnswerDiv>
							</GroupA>
						</PentagonContainer>
					</div>
				</div>
				<Empty space={80} />
				<BlogCtaButton variant="contained" onClick={openModal}>
					실제 역량 평가 사례가 궁금하다면?
				</BlogCtaButton>
				<EmptySpace space={40} />
			</ContentsContainer>
			<ModalA
				zIndex={10001}
				maxWidth="800px"
				bgColor="white"
				isOpen={isOpen}
				onClose={closeModal}
			>
				<PaperA variant="transparent" order="column-center-center" gap={16} px={16} py={0}>
					<SectionSmallTitle>실제 역량 평가 문제 & 답변</SectionSmallTitle>
					<PaperA
						variant="transparent"
						order="column-center-center"
						gap={16}
						px={0}
						py={0}
					>
						<SectionSmallSubTitle>
							당신은 글로벌 가전 브랜드 Dyson의 디지털 마케팅팀에서 최근 출시한
							프리미엄 공기청정기 라인의 온라인 광고 캠페인을 담당하고 있습니다. 지난
							분기 동안 이 제품 라인의 자사 온라인 스토어 판매가 예상보다 저조했으며,
							특히 주요 타겟 그룹에서의 구매 전환율이 낮은 것으로 나타났습니다. 초기
							분석 결과, 주요 원인으로는 다음 두 가지가 지목되었습니다.
						</SectionSmallSubTitle>
						<SectionSmallSubTitle2>
							1. 경쟁 브랜드들의 공격적인 마케팅으로 인한 시장 점유율 감소 <br></br>2.
							소비자들의 높은 가격 민감도와 경기 불황으로 인한 구매 의사 결정 지연
						</SectionSmallSubTitle2>
						<SectionSmallSubTitle>
							온라인 광고 성과는 전반적으로 기대에 미치지 못하고 있으며, 특히 광고
							클릭에서 실제 구매로 이어지는 전환율이 낮은 상황입니다. 현재 상황을
							어떻게 분석하고 온라인 광고에서의 전환율 향상을 위해 어떤 전략과 액션을
							수행할지 서술하세요.
						</SectionSmallSubTitle>
					</PaperA>
					<EmptySpace space={20} />
					<WebpImage
						style={{
							maxWidth: "100%",
						}}
						src="/onepoint/images/renewal/how-section/example-mobile.png"
						alt=""
					/>
				</PaperA>
			</ModalA>
		</ContentsContainer>
	);
};

const PentagonSubTitle = styled.div`
	color: var(--card-bg);
	font-size: 16px;
	font-style: normal;
	font-weight: 800;
	line-height: 120%; /* 19.2px */
	letter-spacing: -0.48px;
`;

const PentagonTitle = styled.div`
	color: var(--card-bg);
	text-align: right;
	font-family: Pretendard;
	font-size: 48px;
	font-style: normal;
	font-weight: 800;
	line-height: 120%; /* 57.6px */
	letter-spacing: -1.44px;
`;

const PentagonTitle2 = styled.div`
	color: var(--card-bg);
	text-align: right;
	font-family: Pretendard;
	font-size: 24px;
	font-style: normal;
	font-weight: 800;
	line-height: 120%; /* 28.8px */
	letter-spacing: -0.72px;
`;

interface PentagonProps {
	backgroundColor?: string;
	width?: string;
	height?: string;
	angle?: number;
}

const PentagonContainer = styled.div`
	flex: 1;
	height: 125px;
	position: relative;
	width: 100%;

	> .column-start-start {
		z-index: 1;
	}
`;

const Pentagon = styled.div<PentagonProps>`
	background-color: ${({ backgroundColor }) => backgroundColor || "#1C1F2E"};
	color: white;
	font-weight: bold;
	width: ${({ width }) => width || "200px"};
	height: ${({ height }) => height || "168px"};
	clip-path: polygon(
		0% 0%,
		100% 0%,
		${({ angle }) => (angle ? angle + "%" : "80%")} 100%,
		0% 100%
	);
	display: flex;
	justify-content: center;
	align-items: center;
	position: absolute;
	top: 0;
	left: 0;

	@media screen and (max-width: 620px) {
		display: none;
	}
`;

const HowToVerifyStepTitle = styled.div`
	color: var(--desc-gray);
	font-family: Pretendard;
	font-size: 14px;
	font-style: normal;
	font-weight: 700;
	line-height: 120%; /* 19.2px */
	letter-spacing: -0.48px;
`;

const HowToVerrifyBigTitle = styled.div`
	color: var(--card-bg);
	font-size: 24px;
	font-style: normal;
	font-weight: 800;
	line-height: 120%;
	letter-spacing: -2.24px;

	.blue {
		color: #387cf6;
	}
`;

const TestExample = styled.div``;
const ExpertList = () => {
	const a = 1;
	return (
		<SwiperSectionContents className="column-center-start">
			<PaperA variant="transparent" order="row-center-center" gap={20} px={16} py={0} fullWidth>
				<SectionTitle>{`원포인트 자체 검증 시스템을 거친\n탑티어 전문가를 만나보세요`}</SectionTitle>
			</PaperA>
			<Empty space={20} />
			<section className="profile-box">
				<SwiperComponent
					navigation={{
						nextEl: ".swiper-button-next-unique",
						prevEl: ".swiper-button-prev-unique",
					}}
					modules={[Pagination, Navigation, Scrollbar, Autoplay]}
					slidesPerView={1}
					slidesPerGroup={1}
					centeredSlides={false}
					loop={true}
					spaceBetween={20}
					pagination={{
						enabled: true,
					}}
					autoplay={{
						delay: 3000,
						disableOnInteraction: true,
						pauseOnMouseEnter: true,
					}}
				>
					{profileDataArray.map((v, i) => (
						<SwiperSlide key={`profileData-${i}`}>
							<div className="profile-item">
								<div className="top-box">
									<WebpImage
										className="profile-img"
										src={v.imageUrl}
										alt={`${v.name} 프로필이미지`}
									/>
									<div className="name">{v.name}</div>
									<div className="job">{v.job}</div>
									<GroupA order="row-center-start" gap={2}>
										<WebpImage
											src="/onepoint/images/renewal/expert-section/verify.png"
											alt=""
											style={{
												width: "16px",
												height: "16px",
											}}
										></WebpImage>
										<span
											style={{
												fontSize: "12px",
												color: "var(--primary)",
											}}
										>
											검증된 전문가
										</span>
									</GroupA>
									<EmptySpace space={8} />
								</div>
								<div className="bottom-box">
									<div className="introduction">{v.introduction}</div>
									<div className="skill-box">
										{[v.tagList, v.skillList].flat().map((skill, i) => (
											<div key={`profile-skill-${i}`} className="skill">
												{skill}
											</div>
										))}
									</div>
									<div
										className="go-profile"
										onClick={() => {
											window.open(v.profileUrl, "_blank");
										}}
									>
										<div>프로필 보기 </div>
									</div>
								</div>
							</div>
						</SwiperSlide>
					))}
				</SwiperComponent>
			</section>
		</SwiperSectionContents>
	);
};
const GetProfileNewsLetter = () => {
	const a = 1;

	const setSnackbareState = useSetRecoilState(globalSnackbarState);
	const [email, setEmail] = React.useState("");

	const [isLoad, setIsLoad] = React.useState(false);

	const handleOnClick = async () => {
		if (validateEmail(email)) {
			try {
				setIsLoad(true);
				await subscribeStibee({
					email: email,
					type: "프로필",
					ads: "O",
				});
			} catch (error) {
				await sendSlackError({
					message: "구독하기 실패" + email,
					title: "구독 프론트엔드 에러",
					channel: "error",
				});
			} finally {
				setIsLoad(false);
			}
			setSnackbareState("구독이 완료되었습니다.");
			setEmail("");
		} else {
			setSnackbareState("이메일 형식이 맞지 않습니다.");
		}
	};

	return (
		<ContentsContainer
			className="row-center-center"
			style={{
				background: "var(--bg-white)",
				borderRadius: "20px",
				padding: "60px 40px",
				gap: "20px",
				boxShadow: "0px 4px 24px 0px rgba(0, 0, 0, 0.07)",
			}}
		>
			<SectionTitle>{`탑티어 전문가의\n프로필을 받아보세요`}</SectionTitle>
			<GroupA order="column-center-start" gap={4} fullWidth>
				<GroupA order="row-center-center" gap={4}>
					<SubscribeInput
						value={email}
						onChange={(e) => setEmail(e.target.value)}
						placeholder="work@email.com"
					></SubscribeInput>
					<SubscribeButton
						variant="contained"
						loading={isLoad}
						id={"subscribe_profile"}
						onClick={handleOnClick}
						sx={{
							flex: 1,
							minWidth: "85px",
						}}
					>
						구독하기
					</SubscribeButton>
				</GroupA>
				<p
					style={{
						color: "var(--desc-gray)",
						fontSize: "14px",
						marginTop: "5px",
						textAlign: "right",
						letterSpacing: "-0.64px",
					}}
				>
					구독시{" "}
					<CustomA
						style={{
							color: "var(--desc-gray)",
							letterSpacing: "-0.64px",
						}}
						target="_blank"
						href="https://notion.1point.kr/privacy"
						rel="noreferrer"
					>
						개인정보 수집 및 이용
					</CustomA>
					에 동의하게 됩니다
				</p>
			</GroupA>
		</ContentsContainer>
	);
};

export const CustomA = styled.a`
	color: black;
	font-size: 14px;
	cursor: pointer;

	&:hover {
		color: #0378ef !important;
	}
`;

const list = [
	{
		title: "퍼포먼스 마케터",
		a: {
			title: "어떤 상황에 고용하나요?",
			list: [
				"목적에 맞는 디지털 광고 구성과 광고비 성과 최적화가 필요할 때",
				"광고비를 사용해 콘텐츠 마케팅 대비 빠른 유입/전환을 만들어야 할 때",
				"소비자 타겟 및 데이터를 광고를 통해 파악해야 할 때",
			],
			exList: [
				"퍼포먼스 마케팅 매체 전략 수립",
				"미디어 믹스 전략 기획",
				"소재 A/B 테스트",
				"소재 셋팅과 성과 최적화",
				"성과 분석 및 리포팅",
				"대행사 활용 시 대행사 핸들링",
				"메타/구글/네이버 키워드 등 필요 매체 운영",
			],
			button: {
				text: "성공 사례 보기",
				url: "https://1point.kr/blog/best-practices/mj-groupby/",
			},
		},
	},
	{
		title: "브랜드 마케터",
		a: {
			title: "어떤 상황에 고용하나요?",
			list: [
				"전반적인 브랜드 전략 수립이 필요할 때",
				"BI를 소비자에게 인식시키기 위한 장기 전략이 필요할 때",
				"소비자에게 사랑받는 브랜드 아이덴티티(BI) 구축이 필요할 때",
			],
			exList: [
				"브랜드 전략 수립 (컨셉/브랜드 네이밍 개발)",
				"브랜드 포지셔닝 전략 수립",
				"브랜드 컨셉 및 핵심가치 등 전략 수립",
				"브랜드 마케팅 캠페인 실행안 기획",
				"브랜드 광고 마케팅 전략 수립",
				"브랜드 마케팅 대행사 활용 시 대행사 핸들링",
			],
			button: {
				text: "성공 사례 보기",
				url: "https://1point.kr/blog/best-practices/philip-startupcode/",
			},
		},
	},
	{
		title: "콘텐츠 마케터",
		a: {
			title: "어떤 상황에 고용하나요?",
			list: [
				"타겟에게 적합하고 신선한 크리에이티브 기획이 필요할 때",
				"일관적인 브랜드 이미지 구축과 커뮤니케이션을 위한 콘텐츠 기획이 필요할 때",
				"SNS 초기 셋팅 시 콘텐츠의 톤앤매너와 방향성 수립이 필요할 때",
			],
			exList: [
				"콘텐츠 마케팅 방향성/매체 전략 수립",
				"콘텐츠 전략과 톤앤매너 전략 수립",
				"이미지/영상 콘텐츠 기획",
				"콘텐츠 발행 및 성과 분석",
				"상세 페이지 기획/개선/가이드/카피라이팅",
				"광고 소재 기획/카피라이팅",
			],
			button: {
				text: "성공 사례 보기",
				url: "https://1point.kr/blog/best-practices/paradot/",
			},
		},
	},
	{
		title: "블로그/뉴스레터 마케터",
		a: {
			title: "어떤 상황에 고용하나요?",
			list: [
				"장기적으로 블로그 콘텐츠를 발행해 소비자의 신뢰도를 올려야 할 때",
				"소비자가 많은 정보를 찾아보는 고관여 제품, B2B 제품 판매 시 특히 적합",
				"유저와의 커뮤니케이션으로 광고비 없이 오가닉 유입을 이끌어야 할 때",
			],
			exList: [
				"블로그 콘텐츠 전략과 톤앤매너 전략 수립",
				"블로그/뉴스레터 콘텐츠 기획 & 작성",
				"블로그/뉴스레터 발행 및 성과 분석",
			],
			button: {
				text: "성공 사례 보기",
				url: "https://1point.kr/blog/best-practices/nry-boundx/",
			},
		},
	},
	{
		title: "이커머스 마케터",
		a: {
			title: "어떤 상황에 고용하나요?",
			list: [
				"자사몰 제품 판매를 위한 마케팅 전략이 필요할 때",
				"광고 클릭율은 높은데 전환이 떨어질 때",
				"자사몰 및 상세 페이지 전반에 대한 개선과 가이드가 필요할 때",
			],
			exList: [
				"자사몰 전환 최적화를 위한 액션 제안과 실행",
				"제품 상세 페이지 개선 기획",
				"전환율 최적화 전략 수립",
				"이커머스 광고 캠페인 기획 및 실행",
				"성과 분석 및 리포팅",
				"대행사 활용 시 대행사 핸들링",
			],
			button: {
				text: "성공 사례 보기",
				url: "https://1point.kr/blog/best-practices/purposed-dreve/",
			},
		},
	},
	{
		title: "CRM 마케터",
		a: {
			title: "어떤 상황에 고용하나요?",
			list: [
				"초기 CRM 전략 및 툴 셋팅이 필요할 때",
				"고객 세그먼트를 체계적으로 관리하고 싶을 때",
				"고객 세그먼트에 맞춰 재구매와 추가 구매를 유도해야 할 때",
			],
			exList: [
				"CRM 툴 셋팅과 캠페인 기획&운영",
				"고객 데이터 분석",
				"고객 세그먼트화",
				"데이터를 통한 고객 만족도 조사 및 개선",
				"채널톡/이메일 캠페인 기획 및 운영",
			],
			button: {
				text: "성공 사례 보기",
				url: "https://1point.kr/blog/",
			},
		},
	},
	{
		title: "SEO/SEM 마케터",
		a: {
			title: "어떤 상황에 고용하나요?",
			list: [
				"검색 엔진에서 회사와 제품 상위 노출이 필요할 때",
				"검색을 통한 오가닉 유입 전략을 세우고 싶을 때",
			],
			exList: [
				"SEO/SEM 현황 점검/전략 도출",
				"검색 엔진 최적화 전략 수립",
				"구글 애널리틱스 분석",
				"키워드 연구 및 분석",
			],
			button: {
				text: "성공 사례 보기",
				url: "https://1point.kr/blog/",
			},
		},
	},
	{
		title: "디자이너",
		a: {
			title: "어떤 상황에 고용하나요?",
			list: [
				"고객에게 신뢰를 주는 일관된 브랜드 아이덴티티(BI/CI) 구축이 필요할 때",
				"사용자 경험(UX/UI)을 개선하여 웹/앱 서비스의 이탈률을 낮추고 싶을 때",
				"마케팅 메시지를 효과적으로 전달하는 상세페이지, 광고 소재 등이 필요할 때",
			],
			exList: [
				"브랜드 아이덴티티(로고, 컬러, 서체) 시스템 구축",
				"웹/앱 서비스의 UX/UI 설계 및 디자인",
				"상세페이지, 이벤트 페이지 등 마케팅 콘텐츠 디자인",
				"SNS 채널(인스타그램, 페이스북) 콘텐츠 디자인",
				"브로슈어, 명함 등 인쇄물 디자인",
				"전체적인 디자인 톤앤매너 수립 및 가이드라인 제작",
			],
			button: {
				text: "성공 사례 보기",
				url: "https://1point.kr/blog",
			},
		},
	},
	{
		title: "영상 소재 제작 전문가",
		a: {
			title: "어떤 상황에 고용하나요?",
			list: [
				"제품/서비스를 매력적으로 보여줄 광고 영상이 필요할 때",
				"시선을 사로잡는 숏폼(릴스, 쇼츠) 콘텐츠를 만들고 싶을 때",
				"브랜드 스토리 등 전문적인 영상이 필요할 때",
				"콘텐츠는 있지만, 영상으로 만드는 데 어려움을 겪을 때",
			],
			exList: [
				"영상 소재 기획, 제작 및 편집",
				"플랫폼별 영상 최적화",
			],
			button: {
				text: "성공 사례 보기",
				url: "https://1point.kr/blog",
			},
		},
	},
];

const Purpose = () => {
	//
	const a = 1;
	return (
		<ContentsContainer className="row-center-center">
			<SectionTitle>{`목적에 맞는 전문가를 매칭 받으세요`}</SectionTitle>
			<EmptySpace space={42} />
			<SectionRight>
				{list.map((faq, i) => (
					<CustomAccordion key={`accordion${i}`} defaultExpanded={i === 0}>
						<AccordionSummary
							expandIcon={<ExpandMoreIcon htmlColor="black" />}
							sx={{
								color: "var(--card-bg)",
								paddingLeft: "24px",
							}}
						>
							<SectionSmallTitle>{faq.title}</SectionSmallTitle>
						</AccordionSummary>
						<AccordionDetails
							sx={{
								color: "black",
								whiteSpace: "pre-wrap",
								background: "white",
								display: "flex",
								flexDirection: "column",
								alignItems: "start",
								gap: "20px",
								paddingBottom: "20px",
								paddingLeft: "24px",
							}}
						>
							<GroupA order="column-start-start" gap={8} fullWidth>
								<GroupA order="column-start-start" gap={8} fullWidth>
									<FAQAnswerTitle>{faq.a.title}</FAQAnswerTitle>
								</GroupA>
								<GroupA order="row-start-between" gap={0} fullWidth>
									<AnswerListUl>
										{faq.a.list.map((item, index) => (
											<FAQAnswerList key={`faq-answer-${index}`}>
												{item}
											</FAQAnswerList>
										))}
									</AnswerListUl>
								</GroupA>
								<EmptySpace space={12} />
								<GroupA order="column-start-start" gap={8} fullWidth>
									<FAQAnswerTitle>{"어떤 업무를 요청하나요?"}</FAQAnswerTitle>
								</GroupA>
								<GroupA order="row-start-between" gap={0} fullWidth>
									<AnswerListUl>
										{faq.a.exList.map((item, index) => (
											<FAQAnswerList key={`faq-answer-ex-${index}`}>
												{item}
											</FAQAnswerList>
										))}
									</AnswerListUl>
								</GroupA>
							</GroupA>
							<FAQButton
								variant="contained"
								onClick={() => {
									window.open(faq.a.button.url);
								}}
							>
								{faq.a.button.text}
							</FAQButton>
						</AccordionDetails>
					</CustomAccordion>
				))}
			</SectionRight>
		</ContentsContainer>
	);
};
const Process = () => {
	const a = 1;

	return (
		<ContentsContainer className="column-center-start">
			<GroupA order="column-start-center" gap={20}>
				<SectionTitle>{`상담에서 계약까지 7일\n빠른 업무 투입이 가능합니다`}</SectionTitle>
			</GroupA>
			<EmptySpace space={40} />
			<GroupA order="column-start-between" gap={16} fullWidth>
				{ProcessCardList.map((item, index) => (
					<WhyCard
						key={"ProcessCard" + index}
						imgSrc={item.imgSrc}
						title={item.title}
						subTitle={item.subTitle}
					/>
				))}
			</GroupA>
		</ContentsContainer>
	);
};
const CIList = () => {
	// 로고 데이터 배열 - ci-images 폴더의 모든 파일들
	const allLogoData = [
		"/onepoint/images/renewal/ci-images/youhan.png",
		"/onepoint/images/renewal/ci-images/scatter.png",
		"/onepoint/images/renewal/ci-images/r2w.png",
		"/onepoint/images/renewal/ci-images/lgelec.png",
		"/onepoint/images/renewal/ci-images/levit.png",
		"/onepoint/images/renewal/ci-images/kearney.png",
		"/onepoint/images/renewal/ci-images/jandi.png",
		"/onepoint/images/renewal/ci-images/fursys.png",
		"/onepoint/images/renewal/ci-images/frendliai.png",
		"/onepoint/images/renewal/ci-images/freedom.png",
		"/onepoint/images/renewal/ci-images/esther.png",
		"/onepoint/images/renewal/ci-images/dotus.png",
		"/onepoint/images/renewal/ci-images/salady.png",
		"/onepoint/images/renewal/ci-images/celimax.png",
		"/onepoint/images/renewal/ci-images/heum.png",
		"/onepoint/images/renewal/ci-images/rsquare.png",
		"/onepoint/images/renewal/ci-images/apartmentary.png",
		"/onepoint/images/renewal/ci-images/mckinsey.png",
		"/onepoint/images/renewal/ci-images/lguplus.png",
		"/onepoint/images/renewal/ci-images/hanwha.png",
	];

	// 첫 번째 줄용 로고 (앞쪽 10개)
	const firstRowLogos = allLogoData.slice(0, 10);
	// 두 번째 줄용 로고 (뒤쪽 10개)
	const secondRowLogos = allLogoData.slice(10, 20);

	return (
		<div
			className="ci-list"
			style={{ width: "100vw", marginLeft: "calc(-50vw + 50%)", background: "white" }}
		>
			<div style={{ maxWidth: "768px", margin: "0 auto", padding: "0 10px" }}>
				<SectionTitle>성장하는 기업은 원포인트를 이용합니다</SectionTitle>
				<EmptySpace space={40} />
			</div>

			{/* 로고 슬라이더 섹션 - 전체 화면 너비 */}
			<div style={{ width: "100vw", overflow: "hidden", padding: "0 10px" }}>
				{/* 첫 번째 줄 - 왼쪽으로 흐름 */}
				<div style={{ marginBottom: "20px" }}>
					<SwiperComponent
						modules={[Autoplay]}
						slidesPerView="auto"
						spaceBetween={0}
						loop={true}
						freeMode={true}
						autoplay={{
							delay: 0,
							disableOnInteraction: false,
						}}
						speed={4000}
						style={{
							width: "100%",
							transitionTimingFunction: "linear",
						}}
					>
						{[...firstRowLogos, ...firstRowLogos, ...firstRowLogos].map(
							(logo, index) => (
								<SwiperSlide
									key={`logo-1-${index}`}
									style={{
										width: "140px",
										display: "flex",
										alignItems: "center",
										justifyContent: "center",
									}}
								>
									<div
										style={{
											height: "50px",
											display: "flex",
											alignItems: "center",
											justifyContent: "center",
											transition: "all 0.3s ease",
										}}
									>
										<WebpImage
											src={logo}
											alt={`company-${index + 1}`}
											style={{
												objectFit: "contain",
												height: "50px",
											}}
										/>
									</div>
								</SwiperSlide>
							),
						)}
					</SwiperComponent>
				</div>

				{/* 두 번째 줄 - 오른쪽으로 흐름 */}
				<div>
					<SwiperComponent
						modules={[Autoplay]}
						slidesPerView="auto"
						spaceBetween={0}
						loop={true}
						freeMode={true}
						dir="rtl"
						autoplay={{
							delay: 0,
							disableOnInteraction: false,
						}}
						speed={4000}
						style={{
							width: "100%",
							transitionTimingFunction: "linear",
						}}
					>
						{[...secondRowLogos, ...secondRowLogos, ...secondRowLogos]
							.slice()
							.reverse()
							.map((logo, index) => (
								<SwiperSlide
									key={`logo-2-${index}`}
									style={{
										width: "140px",
										display: "flex",
										alignItems: "center",
										justifyContent: "center",
									}}
								>
									<div
										style={{
											height: "50px",
											display: "flex",
											alignItems: "center",
											justifyContent: "center",
											transition: "all 0.3s linear",
										}}
									>
										<WebpImage
											src={logo}
											alt={`company-${index + 1}`}
											style={{
												objectFit: "contain",
												height: "50px",
											}}
										/>
									</div>
								</SwiperSlide>
							))}
					</SwiperComponent>
				</div>
			</div>
		</div>
	);
};

const ReviewList = () => (
	<ContentsContainer className="column-center-start">
		<ReviewContainer>
			<SwiperComponent
				modules={[Pagination, Scrollbar, Autoplay]}
				slidesPerView={1}
				slidesPerGroup={1}
				centeredSlides={false}
				loop={true}
				spaceBetween={20}
				pagination={{
					clickable: true,
					el: ".c-list-pagination2",
				}}
				autoplay={{
					delay: 5000,
					disableOnInteraction: true,
					pauseOnMouseEnter: true,
				}}
				breakpoints={{
					600: {
						slidesPerView: 2,
						slidesPerGroup: 2,
						spaceBetween: 20,
						centeredSlides: false,
						autoplay: {
							delay: 5000,
							disableOnInteraction: true,
							pauseOnMouseEnter: true,
						},
					},
				}}
			>
				{ReviewData.map((v, i) => (
					<SwiperSlide key={`review-${i}`}>
						<ReviewCard>
							<GroupA order="column-center-start" gap={12}>
								<GroupA order="column-center-start" gap={8}>
									<div className="title">{v.title}</div>
									<div className="desc">{v.description}</div>
								</GroupA>
								<GroupA order="column-start-start" gap={8} fullWidth>
									<WebpImage className="img" src={v.img} alt="" />
									<div className="name">
										{v.company} {v.name ? `| ${v.name} ${v.position}` : ""}
									</div>
								</GroupA>
							</GroupA>
						</ReviewCard>
					</SwiperSlide>
				))}
			</SwiperComponent>
		</ReviewContainer>
		<EmptySpace space={24} />
		<CListPagination className="c-list-pagination2 row-center-center"></CListPagination>
	</ContentsContainer>
);

const BestPractice = () => {
	//
	const a = 1;
	return (
		<ContentsContainer className="column-center-start">
			<SectionTitle>{"원포인트 고객사의\n실제 성공 사례입니다"}</SectionTitle>
			<Empty space={40} />
			<GroupA order="row-center-center" gap={8} bgColor="" style={{ rowGap: "16px", flexWrap: "wrap" }}>
				{BpList.map((v, i) => (
					<BpCard
						key={`bp-card-${i}`}
						onClick={() => {
							window.open(v.url);
						}}
					>
						<div
							style={{
								height: "100%",
								width: "100%",
							}}
							className="column-start-between"
						>
							<WebpImage className="img" src={v.imgSrc} alt="bp_ap.png" />
							<PaperA
								variant="transparent"
								px={20}
								py={20}
								order="column-start-start"
								gap={8}
							>
								<div className="title">{v.title}</div>
								<div className="card">{v.name}</div>
							</PaperA>
						</div>
					</BpCard>
				))}
			</GroupA>
			<EmptySpace space={40} />
			<BlogCtaButton
				variant="contained"
				onClick={() => {
					window.open("https://1point.kr/blog/best-practices/");
				}}
			>
				더 보러가기
			</BlogCtaButton>
		</ContentsContainer>
	);
};

const BlogSection = () => {
	//
	const a = 1;
	return (
		<ContentsContainer className="column-center-center">
			<SectionTitle>{`검증된 전문가의\n인사이트를 만나보세요`}</SectionTitle>
			<Empty space={40} />
			<GroupA order="row-center-center" gap={8}>
				{InsightList.map((v, i) => (
					<InsightCard
						key={`insight-card-${i}`}
						onClick={() => {
							window.open(v.url);
						}}
					>
						<WebpImage className="thumb" src={v.imgSrc} />
						<PaperA
							variant="transparent"
							px={16}
							py={16}
							order="column-start-start"
							gap={4}
						>
							<GroupA order="column-start-start" gap={8}>
								{/* <div className="tag">{v.type}</div> */}
								<div className="title">{v.title}</div>
							</GroupA>
							<div className="name">by {v.name}</div>
						</PaperA>
					</InsightCard>
				))}
			</GroupA>

			<EmptySpace space={40} />
			<BlogCtaButton
				variant="contained"
				onClick={() => {
					window.open("https://1point.kr/blog/insights/");
				}}
			>
				더 보러가기
			</BlogCtaButton>
		</ContentsContainer>
	);
};
const FAQSection = () => {
	//
	const a = 1;
	return (
		<ContentsContainer className="column-center-start">
			<SectionTitle>{`자주 묻는 질문`}</SectionTitle>
			<EmptySpace space={40} />
			<div>
				{faqListClient[0].map((faq, i) => (
					<CustomAccordion key={`accordion-faq-${i}`} defaultExpanded={i === 0}>
						<AccordionSummary
							expandIcon={<ExpandMoreIcon htmlColor="black" />}
							sx={{
								color: "var(--card-bg)",
								fontSize: "14px",
							}}
						>
							<FAQAnswerTitle>Q. {faq.title}</FAQAnswerTitle>
						</AccordionSummary>
						<AccordionDetails
							sx={{
								color: "black",
								whiteSpace: "pre-wrap",
								background: "white",
								display: "flex",
								flexDirection: "column",
								alignItems: "start",
								gap: "20px",
								paddingBottom: "20px",
								border: "none",
							}}
						>
							<FAQAnswerDiv>{faq.answer}</FAQAnswerDiv>
						</AccordionDetails>
					</CustomAccordion>
				))}
			</div>
			<EmptySpace space={120} />
		</ContentsContainer>
	);
};

const HowToAnswerDiv = styled.div`
	color: var(--primary);
	font-size: 14px;
	font-style: normal;
	font-weight: 700;
	line-height: 150%; /* 24px */
	letter-spacing: -0.64px;
`;

const HowAnswerDiv = styled.div`
	color: var(--desc-gray);
	font-size: 16px;
	font-style: normal;
	font-weight: 500;
	line-height: 150%; /* 24px */
	letter-spacing: -0.64px;
`;

const FAQAnswerDiv = styled.div`
	color: var(--desc-gray);
	font-size: 14px;
	font-style: normal;
	font-weight: 500;
	line-height: 150%; /* 24px */
	letter-spacing: -0.64px;
`;

const CtaImageBox = styled.div`
	position: absolute;
	padding: 4px;
	border-radius: 4px;
	background: #f6f7f8;

	box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.04);
`;

const MainCtaButton = styled(Button)`
	display: flex;
	padding: 12px 24px;
	justify-content: center;
	align-items: center;
	gap: 10px;
	border-radius: 12px;
	color: #fff;
	text-align: center;
	font-size: 16px;
	font-style: normal;
	font-weight: 700;
	line-height: 130%; /* 31.2px */
	letter-spacing: -0.96px;
	width: 200px;
	box-shadow: 0px 6px 20px 0px rgba(56, 124, 246, 0.2);
	transition: transform 0.2s ease, box-shadow 0.2s ease !important;

	&:hover {
		transform: translateY(-2px);
		box-shadow: 0px 10px 28px 0px rgba(56, 124, 246, 0.3) !important;
	}
`;

const BlogCtaButton = styled(Button)`
	display: flex;
	padding: 12px 20px;
	justify-content: center;
	align-items: center;
	gap: 10px;
	min-width: fit-content;
	border-radius: 4px;
	background-color: var(--card-bg);

	&:hover {
		background-color: var(--bg);
	}

	color: white;
	text-align: center;
	font-size: 14px;
	font-style: normal;
	font-weight: 800;
	line-height: 130%; /* 20.8px */
	letter-spacing: -0.48px;
`;

const MatinCtaContentsInner = styled.div`
	gap: 0px;

	.cta-title-box {
		span {
			color: var(--card-bg);
			text-align: center;
			font-size: 28px;
			font-style: normal;
			font-weight: 800;
			line-height: 116%; /* 55.68px */
			letter-spacing: -1.92px;
		}
		.blue {
			color: var(--primary);
		}
	}
`;

const MainCtaContentsContainer = styled.div`
	padding-top: 60px;
	padding-bottom: 0px;
	width: 100%;
	position: relative;
`;

interface ProcessCardProps {
	imgSrc: string;
	title: string;
	subTitle: string;
}

type WhyCardProps = ProcessCardProps;

const WhyCardList = [
	{
		imgSrc: "/onepoint/images/renewal/why-section/why1.png",
		title: "정규직 채용이 부담스러워요",
		subTitle:
			"잘하는 마케터가 필요하나 파트타임을 원하거나,\n사업 변동성이 커서 유연한 고용이 필요할 때",
	},
	{
		imgSrc: "/onepoint/images/renewal/why-section/why2.png",
		title: "신규 전략 수립이 필요합니다",
		subTitle:
			"대행사가 깊이 고민해주지 않아서 아쉽거나,\n새로운 전략 수립이 필요하나 CMO가 없을 때",
	},
	{
		imgSrc: "/onepoint/images/renewal/why-section/why3.png",
		title: "내부 역량 강화를 원합니다",
		subTitle:
			"대표/임원이 직접 배워 시스템을 구축하고 싶거나,\n내부 주니어 마케터의 사수가 필요할 때",
	},
	{
		imgSrc: "/onepoint/images/renewal/why-section/why4.png",
		title: "특정 전문성이 단기로 필요합니다",
		subTitle:
			"새로운 시도를 위해 특정 스킬/경험이 필요하거나,\n기존 마케팅 방식과 시스템을 점검받고 싶을 때",
	},
];

const WhyCard = (props: WhyCardProps) => {
	const { imgSrc, title, subTitle } = props;
	return (
		<WhyCardBoxMobile>
			<WebpImage
				style={{
					width: "36px",
					height: "36px",
				}}
				src={imgSrc}
				alt=""
			/>
			<GroupA order="column-start-start" gap={8}>
				<div className="title">{title}</div>
				<div className="subTitle">{subTitle}</div>
			</GroupA>
		</WhyCardBoxMobile>
	);
};

const WhyCardBoxMobile = styled.div`
	display: flex;
	flex: 1;
	padding: 16px 10px;
	width: 100%;
	align-items: flex-start;
	gap: 8px;
	border-radius: 4px;
	border: 1px solid rgba(0, 0, 0, 0.06);
	background: #fff;
	box-shadow: 0px 2px 9px 0px rgba(0, 0, 0, 0.04);

	.title {
		color: var(--card-bg);
		font-family: Pretendard;
		font-size: 18px;
		font-style: normal;
		font-weight: 700;
		line-height: 130%; /* 31.2px */
		letter-spacing: -0.72px;
	}

	.subTitle {
		color: var(--desc-gray);
		font-family: Pretendard;
		font-size: 14px;
		font-style: normal;
		font-weight: 500;
		line-height: 150%; /* 30px */
		letter-spacing: -0.8px;
	}
`;

const ProcessCardList = [
	{
		imgSrc: "/onepoint/images/renewal/process/process_1.png",
		title: "매칭 컨설팅",
		subTitle: "마케터 출신의 매칭 컨설턴트와\n요청 업무에 대해 논의합니다.",
	},
	{
		imgSrc: "/onepoint/images/renewal/process/process_2.png",
		title: "최적 매칭",
		subTitle: "개별 기업의 특성과 니즈에 맞춘\n최적 전문가를 추천받습니다.",
	},
	{
		imgSrc: "/onepoint/images/renewal/process/process_3.png",
		title: "인터뷰",
		subTitle: "화상 미팅을 통해 전문가의\n역량과 적극성을 검증합니다.",
	},
	{
		imgSrc: "/onepoint/images/renewal/process/process_4.png",
		title: "계약",
		subTitle: "계약 사항 협의를 완료하고\n전문가와 업무를 시작합니다.",
	},
];

const ProcessCard = (props: ProcessCardProps) => {
	const { imgSrc, title, subTitle } = props;
	return (
		<ProcessCardBox className="column-start-center">
			<GroupA order="row-center-center" gap={8}>
				<WebpImage
					src={imgSrc}
					alt=""
					style={{
						width: "36px",
						height: "36px",
					}}
				/>
				<div className="title">{title}</div>
			</GroupA>
			<div className="subTitle">{subTitle}</div>
		</ProcessCardBox>
	);
};

const ProcessCardBox = styled.div`
	padding: 24px 10px;
	gap: 10px;
	flex: 1 0 100%;
	border-radius: 4px;
	border: 1px solid rgba(0, 0, 0, 0.06);
	width: 100%;
	background: #fff;
	box-shadow: 0px 2px 9px 0px rgba(0, 0, 0, 0.04);

	picture {
		display: flex;
	}

	.title {
		color: var(--card-bg);
		font-size: 20px;
		font-style: normal;
		font-weight: 700;
		line-height: 130%; /* 31.2px */
		letter-spacing: -0.72px;
	}

	.subTitle {
		color: var(--desc-gray);
		font-size: 16px;
		font-style: normal;
		font-weight: 500;
		line-height: 150%; /* 30px */
		letter-spacing: -0.8px;
	}
`;

const ConsultantCardListBox = styled.div`
	width: 200px;
	flex: 0;
	flex-shrink: 0;
	max-width: 600px;
`;

const ReviewCard = styled.div`
	display: flex;
	padding: 24px 16px;
	flex-direction: column;
	align-items: flex-start;
	gap: 16px;
	flex: 1 0 100%;
	border-radius: 4px;
	border: 1px solid rgba(0, 0, 0, 0.06);
	background: #fff;
	box-shadow: 0px 2px 9px 0px rgba(0, 0, 0, 0.04);

	.title {
		color: var(--card-bg);
		font-family: Pretendard;
		font-size: 20px;
		font-style: normal;
		font-weight: 700;
		line-height: 130%; /* 31.2px */
		letter-spacing: -0.72px;
		height: 50px;
		width: 100%;
	}

	@media screen and (min-width: 600px) {
		.title {
			height: 60px;
		}
	}

	.desc {
		color: var(--desc-gray);
		font-family: Pretendard;
		font-size: 14px;
		font-style: normal;
		font-weight: 500;
		line-height: 150%; /* 24px */
		letter-spacing: -0.64px;
		height: 100px;
	}

	.img {
		height: 30px;
		flex-shrink: 0;
		margin-top: 10px;
		margin-bottom: 10px;
	}

	.name {
		color: var(--card-bg);
		font-family: Pretendard;
		font-size: 14px;
		font-style: normal;
		font-weight: 800;
		line-height: 130%; /* 20.8px */
		letter-spacing: -0.48px;
	}
`;

const ConsultantCard = styled.div`
	display: flex;
	padding: 30px 2px 13px 2px;
	flex-direction: column;
	justify-content: flex-end;
	align-items: center;
	gap: 12px;
	border-radius: 4px;
	border: 1px solid rgba(0, 0, 0, 0.06);
	background: #fff;
	box-shadow: 0px 2px 9px 0px rgba(0, 0, 0, 0.04);

	.profile-img {
		width: 88px;
		height: 88px;
		border-radius: 50%;
		object-fit: cover;
	}

	.name {
		color: var(--card-bg);
		text-align: center;
		font-family: Pretendard;
		font-size: 24px;
		font-style: normal;
		font-weight: 800;
		line-height: 120%; /* 28.8px */
		letter-spacing: -0.96px;
	}

	.desc {
		color: var(--desc-gray);
		text-align: center;
		font-family: Pretendard;
		font-size: 16px;
		font-style: normal;
		font-weight: 500;
		line-height: 150%; /* 24px */
		letter-spacing: -0.64px;
	}
`;

const MainContentsContainer = styled.div`
	gap: 80px;

	.ci-list .swiper-wrapper {
		transition-timing-function: linear !important;
		/* 추가: 모바일에서 드래그 시 끊김 방지 */
		-webkit-transition-timing-function: linear !important;
	}

	.hidden {
		opacity: 0;
		pointer-events: none;
	}

	.floating {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		gap: 10px;
		position: fixed;
		bottom: 50px;
		left: 50%;
		transform: translateX(-50%);
		z-index: 1000;
	}

	.floating-btn-apply,
	.floating-btn-consult {
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: center;
		font-size: 18px;
		font-weight: bold;
		padding: 10px 10px;
		padding-right: 5px;
		border-radius: 30px;
		width: 230px;
		cursor: pointer;
		height: 60px;
		box-shadow: 0 19px 38px rgba(0, 0, 0, 0.5);
		transition: 0.3s ease;

		&:hover {
			transform: translateY(-4px);
			box-shadow: 0 24px 48px rgba(0, 0, 0, 0.6);
		}
	}

	.floating-btn-apply {
		background-color: var(--primary);
		color: white;
	}

	.floating-btn-consult {
		background-color: white;
		color: var(--primary);
	}

	@media screen and (max-width: 768px) {
		.floating-btn-apply,
		.floating-btn-consult {
			width: 200px;
			height: 50px;
			border-radius: 50px;
			font-size: 16px;
		}
	}
`;

const ContentsContainer = styled.section`
	width: 100%;
	max-width: 768px;
	padding: 0 10px;
	position: relative;
`;

const SectionTitle = styled.div`
	color: var(--card-bg);
	text-align: center;
	font-size: 24px;
	font-style: normal;
	font-weight: 800;
	line-height: 120%; /* 48px */
	letter-spacing: -1.6px;
`;

const SectionLargeTitle = styled.div`
	color: var(--primary);
	font-size: 24px;
	font-style: normal;
	font-weight: 800;
	line-height: 120%; /* 48px */
	letter-spacing: -1.6px;
`;

const SectionTitleLeft = styled.div`
	color: var(--card-bg);
	font-size: 24px;
	font-style: normal;
	font-weight: 800;
	line-height: 120%; /* 48px */
	letter-spacing: -1.6px;
`;

const SectionSubTitle = styled.div`
	color: var(--desc-gray);
	text-align: center;
	font-size: 16px;
	font-style: normal;
	font-weight: 500;
	line-height: 130%; /* 30px */
	letter-spacing: -0.8px;
`;

const SectionSmallTitle = styled.div`
	color: var(--card-bg);
	text-align: center;
	font-size: 20px;
	font-style: normal;
	font-weight: 800;
	line-height: 120%; /* 38.4px */
	letter-spacing: -1.28px;

	> span {
		color: var(--primary);
	}
`;

const SectionSmallSubTitle = styled.div`
	color: var(--primary);
	text-align: left;
	font-size: 16px;
	font-style: normal;
	font-weight: 500;
	line-height: 150%; /* 30px */
	letter-spacing: -0.8px;
	max-width: 816px;
`;

const SectionSmallSubTitle2 = styled.div`
	color: var(--card-bg);
	text-align: left;
	width: 100%;
	font-size: 16px;
	font-style: normal;
	font-weight: 500;
	line-height: 150%; /* 30px */
	letter-spacing: -0.8px;
	max-width: 816px;
`;

interface ProfileData {
	name: string;
	job: string;
	introduction: string;
	tagList: string[];
	skillList: string[];
	imageUrl: string;
	profileUrl: string;
}

const profileDataArray: ProfileData[] = [
	{
		name: "hani",
		job: "콘텐츠·브랜드 마케터 7년차",
		introduction:
			"다양한 규모의 인하우스 경험을 바탕으로\n온·오프라인 브랜드 마케팅 전략과 실무를\n모두 수행하는 전략형 마케터",
		tagList: [
			"뷰티/화장품",
			"라이프스타일",
			"F&B",
			"SaaS"
		],
		skillList: [
			"Google",
			"Meta",
			"LinkedIn",
			"네이버",
			"카카오",
			"콘텐츠 기획"
		],
		imageUrl: "/onepoint/assets/images/main/profile/hani.jpg",
		profileUrl: "https://notion.1point.kr/expert/profile/hani"	
	},
	{
		"name": "강제인",
		"job": "콘텐츠 마케터 9년차",
		"introduction": "브랜드 맥락을 기반으로\n콘텐츠와 크리에이티브를 설계하고\n성과로 연결하는 콘텐츠 마케터",
		"tagList": ["여행/레저", "교육", "SaaS", "플랫폼"],
		"skillList": ["콘텐츠 기획/전략", "소재/상세 페이지 기획", "Figma", "Meta"],
		"imageUrl": "/onepoint/assets/images/main/profile/kangjane.jpg",
		"profileUrl": "https://notion.1point.kr/expert/profile/kangjane"
	},
	{
		name: "댄디라이언",
		job: "콘텐츠 마케터 14년차",
		introduction:
			"기획부터 디자인·제작까지 전 과정을 아우르며\n감각적인 콘텐츠로 브랜드 스토리를 만드는\n올인원 콘텐츠·브랜딩 마케터",
		tagList: [
			"레저",
			"여행/아웃도어/부동산",
			"스포츠/패션",
			"자동차"
		],
		skillList: [
			"바이럴 마케팅",
			"콘텐츠 마케팅",
			"Meta",
			"네이버 SNS"
		],
		imageUrl: "/onepoint/assets/images/main/profile/dandylion.jpg",
		profileUrl: "https://notion.1point.kr/expert/profile/dandylion"
	},
	{
		name: "루시",
		job: "퍼포먼스 마케터 9년차",
		introduction:
			"콘텐츠·브랜딩·퍼포먼스를 아우르는\n경험과 10명 규모 팀 리딩 경험을 보유한\n시니어 퍼포먼스 마케터",
		tagList: [
			"뷰티/화장품",
			"패션",
			"앱 ",
			"SNS",
			"글로벌"
		],
		skillList: [
			"Google",
			"Meta",
			"네이버",
			"카카오",
			"퍼포먼스 전략",
		],
		imageUrl: "/onepoint/assets/images/main/profile/lucy.jpg",
		profileUrl: "https://notion.1point.kr/expert/profile/lucy"
	},
	// {
	// 	name: "제이",
	// 	job: "그로스 마케터 11년차",
	// 	introduction:
	// 		"재미와 의미가 있는 일을 찾아\n문제를 정의하고 해결하는\n11년차 그로스 마케터",
	// 	tagList: ["커머스", "인사/비즈니스", "교육"],
	// 	skillList: ["마케팅전략", "데이터분석", "Meta", "Google"],
	// 	imageUrl: "/onepoint/assets/images/main/profile/jay.jpg",
	// 	profileUrl: "https://notion.1point.kr/expert/profile/jay",
	// },
	// {
	// 	name: "데이",
	// 	job: "퍼포먼스 마케터 10년차",
	// 	introduction: "Meta 전문, 커머스 전문\n10년차 퍼포먼스마케터\n\n",
	// 	tagList: ["패션", "홈리빙/생활용품", "유아동"],
	// 	skillList: ["Meta", "네이버", "카카오"],
	// 	imageUrl: "/onepoint/assets/images/main/profile/day.jpg",
	// 	profileUrl: "https://notion.1point.kr/expert/profile/day",
	// },
	{
		name: "M-J",
		job: "퍼포먼스 마케터 7년차",
		introduction:
			"서비스 중심 B2C부터\n채용/교육/SaaS 분야 B2B까지\n다양한 광고 운영 이력의 전문 마케터",
		tagList: ["솔루션", "교육", "인사/비즈니스"],
		skillList: ["GA/GTM", "마케팅전략", "데이터분석"],
		imageUrl: "/onepoint/assets/images/main/profile/mj.jpg",
		profileUrl: "https://notion.1point.kr/expert/profile/mj",
	},
	// {
	// 	name: "Max",
	// 	job: "PM/PO 5년차",
	// 	introduction:
	// 		"브랜드 운영에 최적화된 이력과\n세일즈&광고 구조화 역량을 갖춘\n올라운더 프로젝트 리더",
	// 	tagList: ["커머스", "뷰티/화장품", "헬스케어/바이오"],
	// 	skillList: ["광고구조화", "콘텐츠기획", "프로젝트리딩"],
	// 	imageUrl: "/onepoint/assets/images/main/profile/son.jpeg",
	// 	profileUrl: "https://notion.1point.kr/expert/profile/max",
	// },
	// {
	// 	name: "Claire",
	// 	job: "그로스 마케터 12년차",
	// 	introduction:
	// 		"글로벌 대기업부터 스타트업까지\n다양한 마케팅 리드 경험으로\n딱 필요한 마케팅 전략을 제시하는 전문가",
	// 	tagList: ["헬스케어/바이오", "컨텐츠/예술", "제조/하드웨어"],
	// 	skillList: ["마케팅전략", "브랜드전략", "SEM"],
	// 	imageUrl: "/onepoint/assets/images/main/profile/claire.jpg",
	// 	profileUrl: "https://notion.1point.kr/expert/profile/claire",
	// },
	{
		name: "hidy",
		job: "그로스 마케터 7년차",
		introduction:
			"유입부터 재구매까지\n비즈니스의 성장에 필요한 A to Z를\n디스커션 할 수 있는 시니어 마케터",
		tagList: ["커머스", "패션", "뷰티/화장품"],
		skillList: ["소재기획", "이미지/영상제작", "콘텐츠기획"],
		imageUrl: "/onepoint/assets/images/main/profile/hidy.jpg",
		profileUrl: "https://notion.1point.kr/expert/profile/hidy",
	},
	// {
	// 	name: "nry",
	// 	job: "퍼포먼스 마케터 4년차",
	// 	introduction:
	// 		"타깃 고객을 겨냥하는 마케팅 기획력과\n디테일한 광고 실무 능력,\n빠른 실행력까지 갖춘 마케팅 전문가",
	// 	tagList: ["모빌리티/교통", "커머스", "물류"],
	// 	skillList: ["네이버", "Meta", "카카오"],
	// 	imageUrl: "/onepoint/assets/images/main/profile/nry.jpg",
	// 	profileUrl: "https://notion.1point.kr/expert/profile/nry",
	// }
];

const SwiperSectionContents = styled(ContentsContainer)`
	.swiper-pagination {
		position: relative;
		width: 100px !important;
	}

	.swiper-horizontal > .swiper-pagination-bullets,
	.swiper-pagination-bullets.swiper-pagination-horizontal {
		left: 50%;
		transform: translateX(-50%);
		bottom: -20px;
		width: 300px !important;
	}

	.swiper-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet,
	.swiper-pagination-horizontal.swiper-pagination-bullets .swiper-pagination-bullet {
		background-color: var(--card-bg);
	}
	.profile-box {
		width: 100%;
		max-width: 1200px;
		overflow: hidden;

		.swiper {
			padding-bottom: 50px;
		}

		.swiper-slide {
			display: flex;
			justify-content: center;
			align-items: center;
		}

		.swiper-button-group {
			position: absolute;
			top: 50%;
			transform: translateY(-50%);
			width: 40px;
			height: 40px;
			padding-bottom: 100px;
			cursor: pointer;

			svg {
				color: white;
				font-size: 40px;
			}
		}

		@media (max-width: 1200px) {
			.swiper-button-group {
				display: none;
			}

			.review-box {
				padding-left: 0px;
				padding-right: 0px;
			}

			div.swiper-pagination.swiper-pagination-clickable.swiper-pagination-bullets.swiper-pagination-horizontal {
				span.swiper-pagination-bullet-active {
					background: white;
				}
				span.swiper-pagination-bullet {
					width: 20px;
				}
			}
		}

		.swiper-button-prev-unique {
			left: 0px;
		}

		.swiper-button-next-unique {
			right: 0px;
			z-index: 100;
		}

		.swiper-button-prev {
			color: white;
		}

		.swiper-button-next {
			color: white;
		}

		.swiper-pagination.swiper-pagination-clickable.swiper-pagination-bullets.swiper-pagination-horizontal {
			span.swiper-pagination-bullet-active {
				background: white;
			}
			span.swiper-pagination-bullet {
				width: 30px;
				border-radius: 20px;
			}
		}
	}

	.profile-box {
		.swiper-pagination.swiper-pagination-clickable.swiper-pagination-bullets.swiper-pagination-horizontal {
			span.swiper-pagination-bullet {
				background: black;
			}
		}
	}

	.profile-item {
		display: flex;
		flex-direction: column;
		/* width: 100%; */
		border-radius: 4px;
		position: relative;
		/* background-color: white; */
		border: 1px solid rgba(0, 0, 0, 0.06);
		box-shadow: 0px 2px 9px 0px rgba(0, 0, 0, 0.04);

		.top-box {
			display: flex;
			width: 100%;
			flex-direction: column;
			justify-content: start;
			align-items: start;
			position: relative;
			border-top-right-radius: 40px;
			border-top-left-radius: 40px;
			z-index: 1;
			padding: 0px 25px 0px 25px;
			padding-top: 16px;

			.name {
				color: var(--card-bg);
				font-family: Pretendard;
				font-size: 24px;
				font-style: normal;
				font-weight: 800;
				line-height: 120%; /* 28.8px */
				letter-spacing: -0.96px;
				padding-top: 16px;
			}

			.job {
				color: var(--card-bg);
				font-family: Pretendard;
				font-size: 20px;
				font-style: normal;
				font-weight: 500;
				line-height: 150%; /* 30px */
				letter-spacing: -0.6px;
			}

			.profile-img {
				width: 88px;
				height: 88px;
				border-radius: 100%;
				overflow: hidden;
				object-fit: cover;
			}
		}

		.bottom-box {
			display: flex;
			flex-direction: column;
			justify-content: start;
			align-items: start;
			position: relative;
			flex-wrap: wrap;
			background-color: white;
			border-bottom-right-radius: 40px;
			border-bottom-left-radius: 40px;
			padding: 0px 0px 30px 25px;
			gap: 12px;

			.introduction {
				color: var(--desc-gray);
				font-size: 16px;
				font-style: normal;
				font-weight: 500;
				line-height: 150%; /* 24px */
				letter-spacing: -0.64px;
			}

			.tag-box,
			.skill-box {
				display: flex;
				flex-direction: row;
				justify-content: start;
				align-items: start;
				gap: 0px;
				min-height: 40px;
				flex-wrap: wrap;

				.skill,
				.tag {
					display: flex;
					padding: 0px 0px;
					min-width: fit-content;
					justify-content: center;
					align-items: center;
					gap: 10px;
					color: var(--desc-gray);
					text-align: center;
					font-family: Pretendard;
					font-size: 12px;
					font-style: normal;
					font-weight: 700;
					line-height: 150%; /* 18px */
					letter-spacing: -0.36px;
					padding-right: 14px;
				}
			}

			.go-profile {
				display: flex;
				flex-direction: row;
				justify-content: start;
				align-items: center;
				cursor: pointer;

				> div {
					color: var(--primary);
					font-family: Pretendard;
					font-size: 16px;
					font-style: normal;
					font-weight: 800;
					line-height: 130%; /* 20.8px */
					letter-spacing: -0.64px;
				}
			}
		}
	}

	@media (max-width: 1100px) and (min-width: 800px) {
		.profile-item {
			/* width: 304px;
			height: 304px; */
			* {
				flex-wrap: wrap;
			}

			.top-box {
				.name {
				}

				.job {
				}

				.profile-img {
					top: 25px;
					width: 80px;
					height: 80px;
				}
			}
			.bottom-box {
				.introduction {
					/* font-size: 12px; */
				}
			}
		}
	}

	@media (max-width: 1280px) {
		.profile-item {
			/* width: 304px; */
			/* height: 304px; */

			.top-box {
				.name {
				}

				.job {
				}

				.profile-img {
					/* bottom: -30px;
					width: 60px;
					height: 60px; */
				}
			}
			.bottom-box {
				.introduction {
					/* font-size: 12px; */
				}
			}
		}
	}
`;

const SubscribeInput = styled.input`
	display: flex;
	padding: 12px 102px 12px 16px;
	align-items: center;
	border-radius: 4px;
	background: #edf0f5;
	flex: 1 0 100%;
	border: none;
	color: var(--desc-gray);
	font-size: 16px;
	font-style: normal;
	font-weight: 500;
	line-height: 130%; /* 20.8px */
	letter-spacing: -0.64px;
	width: 100%;
`;

const SubscribeButton = styled(LoadingButton)`
	display: flex;
	padding: 12px 16px;
	justify-content: center;
	align-items: center;
	gap: 10px;
	border-radius: 4px;
	background: var(--primary);
	color: #fff;
	text-align: center;
	font-size: 16px;
	font-style: normal;
	font-weight: 800;
	line-height: 130%; /* 20.8px */
	letter-spacing: -0.64px;
`;

const SectionRight = styled.div`
	flex: 1;
`;

const FAQButton = styled(Button)`
	display: inline-flex;
	padding: 8px 12px;
	justify-content: center;
	align-items: center;
	gap: 10px;
	border-radius: 4px;
	background: var(--primary);
	color: #fff;
	text-align: center;
	font-size: 14px;
	font-style: normal;
	font-weight: 800;
	line-height: 130%; /* 20.8px */
	letter-spacing: -0.64px;
`;

const FAQAnswerTitle = styled.div`
	color: var(--card-bg);
	font-size: 16px;
	font-style: normal;
	font-weight: 700;
	line-height: 150%; /* 30px */
	letter-spacing: -0.8px;
`;

const AnswerListUl = styled.ul`
	margin-left: 0px;
	padding-left: 20px;
`;

const FAQAnswerListUl = styled.ul`
	margin-left: 0px;
	padding-left: 20px;
`;

const FAQAnswerList = styled.li`
	color: var(--desc-gray);
	font-size: 14px;
	font-style: normal;
	font-weight: 500;
	line-height: 150%; /* 24px */
	letter-spacing: -0.64px;
	list-style: disc;
`;

const ConsultantUserList = [
	{
		imgSrc: "/onepoint/images/consultant/jeon.jpg",
		name: "전준현",
		desc: "퍼포먼스 마케터 2년차",
	},
];

const CListPagination = styled.div`
	.swiper-pagination-bullet-active {
		background-color: var(--card-bg) !important;
	}
`;

const ReviewContainer = styled.div`
	width: 100%;
	max-width: 1200px;

	.swiper-pagination-bullet-active {
		background-color: var(--card-bg) !important;
	}
`;

const ReviewData = [
	{
		title: "업계 최고 수준의 마케터를 필요할 때마다 합리적으로",
		description:
			"원포인트는 업계 최고 수준의 마케터를, 필요할 때마다 합리적인 가격으로 활용할 수 있는 서비스입니다.",
		company: "아파트멘터리",
		name: "하아얀",
		position: "전략실장",
		img: "/onepoint/images/renewal/review-section/1-1.png",
	},
	{
		title: "마케팅, 헤매지 않고 시작하는 법",
		description:
			"신규 조직에 내부 전담 인력이 없는 상태에서 GA세팅부터 광고 운영까지, 성공적으로 디지털 마케팅을 시작할 수 있었습니다. 단순 운영 대행이 아닌, 함께 고민하는 파트너와 일하는 것 같아 정말 좋았습니다.",
		company: "한화솔루션",
		name: "김수현",
		position: "프로",
		img: "/onepoint/images/renewal/review-section/1-2.png",
	},
	{
		title: "전문가 퀄리티에 놀랐습니다",
		description:
			"저희가 쉽게 채용할 수 없는 분과, 원하는 기간 만큼만 함께 일할 수 있어서 좋았고 큰 도움을 받았습니다. 특히 전문가 퀄리티에 놀랐습니다.",
		company: "샐러디",
		name: "이건호",
		position: "대표",
		img: "/onepoint/images/renewal/review-section/1-3.png",
	},
	{
		title: "초기 스타트업에게 최고의 선택",
		description:
			"마케터가 필요하지만 정규직 고용은 부담스럽다보니 원포인트를 통해 파트타임 전문가를 고용했습니다. 시간내에 큰 성과를 내기 위해 진심으로 일해주시는 역량있는 마케터를 만나서 많은 도움이 되었습니다.",
		company: "패러닷",
		name: "장진욱",
		position: "대표",
		img: "/onepoint/images/renewal/review-section/1-4.png",
	},
	{
		title: "정규직 채용과 외주 활용 부담을 해결했어요",
		description:
			"정규직을 채용하기에는 제약이 많고, 검증되지 않은 곳에 외주를 맡기기도 부담스러웠습니다. 원포인트를 통해 시간제로 역량있는 마케터와 일할 수 있어 이러한 갈증이 해결되었습니다.",
		company: "셀러노트",
		name: "이종원",
		position: "대표",
		img: "/onepoint/images/renewal/review-section/1-5.png",
	},
	{
		title: "비용이 반으로 줄었는데 성과가 개선됐어요",
		description:
			"마케터 채용 비용의 50%로 실적은 계속적으로 향상되고 있어요! 좋은 시니어 마케터분을 찾으신다면 관리까지 꼼꼼하게 해주는 원포인트 추천합니다!",
		company: "소프트스퀘어드",
		name: "윤수진",
		position: "",
		img: "/onepoint/images/renewal/review-section/1-6.png",
	},
	{
		title: "더 이상 헤매지 않고 마케팅을 하게 되었습니다",
		description:
			"마케팅은 경험이 중요하다고 생각합니다. 고급 숙련자의 경험을 바탕으로 마케팅을 진행하고 배울 수 있어서 추천합니다. 더 이상 주니어들끼리 헤매지 않아도 됩니다.",
		company: "투어라이브",
		name: "노경아",
		position: "대표",
		img: "/onepoint/images/renewal/review-section/1-7.png",
	},
	{
		title: "광고 성과가 많이 올랐습니다",
		description:
			"실력있는 인재와 함께하는 것이 좋은 성과의 핵심인데, 원포인트에서 만난 마케팅 전문가님의 도움으로 성과가 많이 올랐습니다",
		company: "펫박스",
		name: "이현석",
		position: "대표",
		img: "/onepoint/images/renewal/review-section/1-8.png",
	},
	{
		title: "더 이상 대행사를 쓰지 않습니다",
		description:
			"마케팅 대행사를 세 곳 정도 써보았지만 모두 마음에 들지 않았습니다. 결국 지금은 원포인트를 통해 숙련된 퍼포먼스 마케터를 파트타임으로 활용하고 있는데, 알아서 캠페인 퍼포먼스 관리를 잘 해주시니 정말 편리합니다.",
		company: "에딧메이트",
		name: "최범익",
		position: "대표",
		img: "/onepoint/images/renewal/review-section/1-9.png",
	},
];

const BpCard = styled.div`
	width: 100%;
	flex-shrink: 0;
	border-radius: 16px;
	overflow: hidden;
	display: flex;
	flex-direction: column;
	justify-content: flex-end;
	cursor: pointer;
	box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.07);

	.img {
		width: 100%;
	}

	.title {
		color: var(--card-bg);
		font-size: 16px;
		font-style: normal;
		font-weight: 700;
		line-height: 130%; /* 26px */
		letter-spacing: -0.6px;
	}

	.card {
		display: inline-flex;
		padding: 4px 8px;
		justify-content: center;
		align-items: center;
		gap: 10px;
		border-radius: 4px;
		background: var(--bg-white);
		color: var(--desc-gray);
		text-align: center;
		font-family: Pretendard;
		font-size: 10px;
		font-style: normal;
		font-weight: 700;
		line-height: 150%; /* 18px */
		letter-spacing: -0.36px;
	}

	@media screen and (min-width: 500px) {
		width: calc(50% - 8px);

		.title {
			height: 60px;
		}
	}
`;

const BpList = [
	{
		name: "마케팅 캠페인",
		title: "샐러디는 어떻게 배달앱 인기 검색어 1위에 올랐을까?",
		imgSrc: "/onepoint/assets/images/main/example/bp_salady.png",
		url: "https://1point.kr/blog/best-practices/salady/",
	},
	{
		name: "콘텐츠 마케팅",
		title: "580억 투자 받은 아파트멘터리가 잘하는 마케터 고용한 방법",
		imgSrc: "/onepoint/assets/images/main/example/bp_ap.png",
		url: "https://1point.kr/blog/best-practices/apartmentary/",
	},
	{
		name: "콘텐츠 마케팅",
		title: "MZ세대 대세 서비스 패러닷이\n대박 콘텐츠를 만들어낸 노하우",
		imgSrc: "/onepoint/assets/images/main/example/paradot.png",
		url: "https://1point.kr/blog/best-practices/paradot/",
	},
	{
		name: "퍼포먼스 마케팅",
		title: "트렌드아이는 어떻게 마케터 채용에\n드는 시간과 비용을 줄였을까?",
		imgSrc: "/onepoint/assets/images/main/example/bp_wdressroom.png",
		url: "https://1point.kr/blog/best-practices/trend-i/",
	},
	{
		name: "그로스 마케팅",
		title: "초기 스타트업 리클이\n경력직 마케터 채용 대신 선택한 것",
		imgSrc: "/onepoint/assets/images/main/example/bp_recl.png",
		url: "https://1point.kr/blog/best-practices/recl/",
	},
	{
		name: "브랜드 마케팅",
		title: "닥터이브가 마케터 정규직 없이\n3개월만에 매출 월 1억을 달성한 방법",
		imgSrc: "/onepoint/assets/images/main/example/purposed-dreve.png",
		url: "https://1point.kr/blog/best-practices/purposed-dreve/",
	},
];

const BigInsightCard = styled.div`
	width: 440px;
	height: 564px;
	flex-shrink: 0;
	border-radius: 4px;
	border: 1px solid rgba(0, 0, 0, 0.06);
	background: #fff;
	flex-grow: 0;
	flex-shrink: 0;
	cursor: pointer;

	.thumb {
		width: 440px;
		flex-shrink: 0;
	}

	.tag {
		display: inline-flex;
		padding: 4px 8px;
		justify-content: center;
		align-items: center;
		gap: 10px;
		border-radius: 4px;
		background: var(--bg-white);
		color: var(--desc-gray);
		text-align: center;
		font-family: Pretendard;
		font-size: 12px;
		font-style: normal;
		font-weight: 700;
		line-height: 150%; /* 18px */
		letter-spacing: -0.36px;
	}

	.title {
		color: var(--card-bg);
		font-family: Pretendard;
		font-size: 16px;
		font-style: normal;
		font-weight: 700;
		line-height: 130%; /* 20.8px */
		letter-spacing: -0.48px;
	}

	.name {
		color: var(--card-bg);
		font-family: Pretendard;
		font-size: 12px;
		font-style: normal;
		font-weight: 500;
		line-height: 150%; /* 18px */
		letter-spacing: -0.48px;
	}
	.text {
		color: var(--desc-gray);
		font-size: 20px;
		font-style: normal;
		font-weight: 500;
		line-height: 150%; /* 30px */
		letter-spacing: -0.8px;
	}
`;

const InsightCard = styled.div`
	width: 100%;
	flex-shrink: 0;
	border-radius: 4px;
	border: 1px solid rgba(0, 0, 0, 0.06);
	background: #fff;
	cursor: pointer;

	.thumb {
		width: 100%;
		flex-shrink: 0;
	}

	.tag {
		display: inline-flex;
		padding: 4px 8px;
		justify-content: center;
		align-items: center;
		gap: 10px;
		border-radius: 4px;
		background: var(--bg-white);
		color: var(--desc-gray);
		text-align: center;
		font-family: Pretendard;
		font-size: 10px;
		font-style: normal;
		font-weight: 700;
		line-height: 150%; /* 18px */
		letter-spacing: -0.36px;
	}

	.title {
		color: var(--card-bg);
		font-family: Pretendard;
		font-size: 16px;
		font-style: normal;
		font-weight: 700;
		line-height: 130%; /* 20.8px */
		letter-spacing: -0.48px;
	}

	.name {
		color: var(--card-bg);
		font-family: Pretendard;
		font-size: 12px;
		font-style: normal;
		font-weight: 500;
		line-height: 150%; /* 18px */
		letter-spacing: -0.48px;
	}

	@media screen and (min-width: 500px) {
		width: calc(50% - 8px);

		.title {
			height: 60px;
		}
	}
`;

const InsightList = [
	{
		name: "연준현",
		title: "초기 스타트업을 위한 마케팅 가이드",
		type: "인사이트",
		imgSrc: "/onepoint/images/renewal/insight-section/1.png",
		url: "https://1point.kr/blog/insights/startup-marketing-guide/",
		text: "초기 스타트업, 어떤 마케팅을 해야 할까요? 라이브 커머스, SEO/SEM, 퍼포먼스, 그로스, 브랜드, 이메일, CPA, 트래픽, 제휴, 콘텐츠 등 이 많은 마케팅 방법 중 초기 스타트업은 어떤 것을 선택해야 할지 목적과 수단에 따른 마케팅에 대해 알아봅니다.",
	},
	{
		name: "레비",
		title: "개발 지식 없이 페이스북 픽셀 설치하는 법",
		type: "인사이트",
		imgSrc: "/onepoint/images/renewal/insight-section/2.png",
		url: "https://1point.kr/blog/insights/meta-pixel-1/",
	},
	{
		name: "데이",
		title: "인스타 광고 vs 메타 광고 3가지 차이점 탐구",
		type: "인사이트",
		imgSrc: "/onepoint/images/renewal/insight-section/3.png",
		url: "https://1point.kr/blog/insights/instagram-vs-meta/",
	},
	{
		name: "콘텐츠온",
		title: "B2B 마케팅에서 고객을 효과적으로 설득하는 방법",
		type: "인사이트",
		imgSrc: "/onepoint/images/renewal/insight-section/4.png",
		url: "https://1point.kr/blog/insights/b2b-success-cases/",
	},
	{
		name: "Miguel",
		title: "퍼포먼스 vs 그로스 마케팅, 차이점과 적용 시기",
		type: "인사이트",
		imgSrc: "/onepoint/images/renewal/insight-section/5.png",
		url: "https://1point.kr/blog/insights/growth-performance-difference/",
	},
];

const CustomAccordion = styled(Accordion)`
	border: none;
	background-color: white;
	width: 100%;
	padding: 0 10px;
	box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.06);

	&.MuiAccordion-root {
		max-width: 100vw !important;
		&:before {
			background-color: transparent !important;
		}
	}
`;

const slideUpFadeMobile = keyframes`
	from {
		transform: translateY(12px);
		opacity: 0;
	}
	to {
		transform: translateY(0);
		opacity: 1;
	}
`;

const MobileRollingTextSpan = styled.span`
	display: inline-block;
	animation: ${slideUpFadeMobile} 0.5s ease forwards;
	vertical-align: bottom;
	position: relative;
	top: -0.5px;
	margin: 0 1px 0 3px;
`;
